// https://www.tiny.cloud/docs/advanced/usage-with-module-loaders/webpack/webpack_es6_npm/

/* Import TinyMCE */
import tinymce from 'tinymce';
window.tinymce = tinymce;

/* Default icons are required for TinyMCE 5.3 or above */
import 'tinymce/icons/default';

/* A theme is also required */
import 'tinymce/themes/silver';

/* Import the skin */
import 'tinymce/skins/ui/oxide/skin.min.css';

/* Import plugins */
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';

/* Import content css */
import 'tinymce/skins/ui/oxide/content.min.css';
import 'tinymce/skins/content/default/content.min.css';

// Custom
import 'tinymce/plugins/wordcount';
import 'tinymce/models/dom';
